<section class="business-service-wrapper">
  <div class="box-container">
    <!-- content -->
    <div class="box">
      <div class="box__left">
        <div class="title desktop" [innerHtml]="'BUSINESS_REGISTRATION.SERVICE.HEADING' | translate"></div>
        <div class="title mobile" [innerHtml]="'BUSINESS_REGISTRATION.SERVICE.HEADING_MOBILE' | translate"></div>
        <div class="detail">{{ 'BUSINESS_REGISTRATION.SERVICE.DETAIL' | translate }} </div>
      </div>

      <div class="box__right">
        <div class="box__card">
          <ng-container *ngFor="let item of ServiceList">
            <div class="box__card-detail"
              ><span class="icon-wrapper"><i class="fa fa-check"></i></span>
              <span>{{ translate.currentLang === 'th' ? item.data.text.th : item.data.text.en }}</span>
            </div>
          </ng-container>

          <div class="box__link">
            <a
              href="https://flowaccount.com/faq/knowledge-base/business-registration-with-flowaccount/"
              rel="nofollow noopener"
              target="_blank"
            >
              <span class="text">{{ 'BUSINESS_REGISTRATION.SERVICE.READ_MORE' | translate }} </span>
              <i class="fas fa-angle-right"></i
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
